import type { FC, ReactNode } from "react"
import React from "react"
import { AccordionPanel } from "@chakra-ui/react"

type CreateProposalStepContentProps = {
  children: ReactNode
  isActive?: boolean
}

const CreateProposalStepContent: FC<CreateProposalStepContentProps> = ({
  children,
  isActive = true,
}) => {
  return isActive ? (
    <AccordionPanel
      bgColor="white"
      color="purple.900"
      pb={{ base: 9, lg: 9 }}
      pt={{ base: 0, lg: 0 }}
      px={{ base: 4, lg: 12 }}
    >
      {children}
    </AccordionPanel>
  ) : null
}

export default CreateProposalStepContent
